import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { PanelMenuModule } from 'primeng/panelmenu';
import { UserRole } from 'src/app/core/auth/user/enum/user-role.enum';
import { UserStore } from 'src/app/core/auth/user/store/user.store';
import { CountryStore } from 'src/app/features/vendor/stores/country.store';

@Component({
  selector: 'app-landing-page',
  imports: [PanelMenuModule, CommonModule, RouterModule],
  standalone: true,
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.css'
})
export class LandingPageComponent implements OnInit {
  constructor(private router: Router, private userStore: UserStore, private countryStore: CountryStore) {}
  ngOnInit(): void {
        const role = this.userStore.role(); // z. B. Enum: Vendor, Customer, Admin
        this.countryStore.loadCountries().subscribe();
        switch (role?.id) {
          case UserRole.Vendor:           
            this.router.navigate(['/vendor-dashboard']);
            break;
          case UserRole.Customer:
            this.router.navigate(['/customer-dashboard']);
            break;
          case UserRole.Admin:
            this.router.navigate(['/vendors']);
            break;
          case UserRole.SystemOwner:
            this.router.navigate(['/admin-systems']);
            break;
          case undefined :
            this.router.navigate(['/unauthorized-role']);
            break;
          default:
            this.router.navigate(['/home']);
        }
  }
}